import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../interfaces';
import { Observable } from 'rxjs';
import { Product } from '../core/models/product';

import * as orderSelector from '../core/store/order/order.selectors';
import * as uiSelector from '../core/store/ui/ui.selectors';
import { Step2Component } from '../step2/step2.component';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Step3Component } from '../step3/step3.component';
import { Step1Component } from '../step1/step1.component';
import { SetIsMobile, SetIsTablette, SetResetStepper } from '../core/store/ui';
import { TranslateService } from '@ngx-translate/core';
import { MatStepper } from '@angular/material';
import { DataService } from '../core/services/data.service';
import { PackDB } from '../core/models/PackDB';
import { delay } from 'rxjs/operators';

@Component({
  selector: 'app-order-steppers',
  templateUrl: './order-steppers.component.html',
  styleUrls: ['./order-steppers.component.scss']
})
export class OrderSteppersComponent implements OnInit {
  $products: Observable<Product[]>;
  $hasImmoAccess: Observable<boolean>;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild(Step1Component) Step1Component: Step1Component;
  @ViewChild(Step2Component) Step2Component: Step2Component;
  @ViewChild(Step3Component) Step3Component: Step3Component;

  invoiceTo: string;
  products: Product[];
  packs: PackDB[];

  constructor(
    private store: Store<AppState>,
    public breakpointObserver: BreakpointObserver,
    translate: TranslateService,
    private dataService: DataService
  ) {
    translate.setDefaultLang('fr');
    this.store.select(uiSelector.getLanguage).subscribe(ln => translate.use(ln));
  }

  ngOnInit() {
    this.dataService.getPacksFromAPI().subscribe(packs => {
      // console.log(packs);
      this.packs = packs;
    });
    /* this.store.select(orderSelector.getProducts).subscribe(pr => (this.products = pr)); */
    // this.dataService.updatePricesOnResolve(this.route.snapshot.data['prices']);
    /* this.store.select(orderSelector.getServices).subscribe(serv => {
      if (this.products && !this.products[0].price) {
        this.store.dispatch(new SetServices(serv));
      }
    }); */
    this.$products = this.store.select(orderSelector.getProducts);
    this.store.select(orderSelector.getInvoiceTo).subscribe(i => (this.invoiceTo = i));

    this.breakpointObserver.observe(['(min-width: 576px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.store.dispatch(new SetIsMobile(false));
      } else {
        this.store.dispatch(new SetIsMobile(true));
      }
    });

    this.breakpointObserver.observe(['(min-width: 768px)']).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.store.dispatch(new SetIsTablette(false));
      } else {
        this.store.dispatch(new SetIsTablette(true));
      }
    });

    this.$hasImmoAccess = this.store.select(orderSelector.getHasImmoAccess);

    this.store
      .select(uiSelector.getResetStepper)
      .pipe(delay(500))
      .subscribe(bool => {
        if (bool && this.stepper && this.stepper !== undefined) {
          this.stepper.reset();
          this.store.dispatch(new SetResetStepper(false));
        }
      });
  }

  get frmStep1() {
    const st = this.Step1Component ? this.Step1Component.step1FormGroup : null;
    if (st) {
      // console.log('st.valid', st.valid);
    }
    return st;
  }

  get frmStep2() {
    return this.Step2Component ? this.Step2Component.step2FormGroup : null;
  }

  get isStep3Valid() {
    const formGP = this.Step3Component ? this.Step3Component.otherDocFormGroup : null;
    const otherValid = this.invoiceTo === 'toOther' && formGP && formGP.valid;
    const valid = this.invoiceTo && this.invoiceTo !== '' && this.invoiceTo !== 'toOther';
    return valid || otherValid;
  }
}
